import React from "react";

import Avatar from "../assets/Avatar2.png";
import Avatar2 from "../assets/Avatar3.png";
import Avatar3 from "../assets/Avatar7.png";
import Avatar4 from "../assets/Avatar5.png";
import Avatar6 from "../assets/Avatar8.png";

const CandidateEmails = () => {
  return (
    <div>
      <div className="flex justify-start items-start flex-row bg-transparent">
        <div className=" flex-1 flex-col gap-6 pt-2">
          <div className="flex self-stretch justify-start items-start flex-col gap-8  pb-[48px] bg-transparent  col-span-12">
            <div className="flex justify-between items-center gap-6 w-full px-8">
              <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col gap-1">
                <p className="self-stretch text-[#181D27] text-2xl  font-semibold">
                  Candidate Emails
                </p>
                <p className="self-stretch text-[#535862] ">
                  Here is your internal communication hub.
                </p>
              </div>
              <div className="flex cursor-pointer items-center flex-row gap-1 py-2.5 px-3.5 bg-[#19BFB7]  rounded-lg ">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.99996 4.16602V15.8327M4.16663 9.99935H15.8333"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="flex justify-center items-center flex-row px-0.5">
                  <span className="text-[#FFFFFF] text-sm font-semibold">
                    New Chat
                  </span>
                </div>
              </div>
            </div>
            <div className="flex self-stretch justify-start items-start flex-col gap-6">
              <div className="flex self-stretch justify-start items-start flex-col gap-6 px-[32px]">
                <div className="flex self-stretch justify-start items-start flex-row gap-6">
                  <div
                    className="flex justify-start items-start flex-col gap-5 w-[261px]"
                    style={{ width: "261px" }}
                  >
                    <div className="flex self-stretch justify-start items-center flex-row gap-5">
                      <p className="flex-1 text-[#181D27] text-lg  font-medium">
                        Direct Messages
                      </p>
                      <div className="flex justify-center items-center flex-row p-2 cursor-pointer border border-[#D5D7DA]  rounded-lg ">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 4.16602V15.8327M4.16669 9.99935H15.8334"
                            stroke="#414651"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="flex self-stretch justify-start items-start flex-col gap-5">
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2 bg-[#FAFFFC] rounded-2xl">
                        <div className="flex justify-end items-center  rounded-[200px] ">
                          <div>
                            <img src={Avatar3} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651]  font-semibold">
                              Ella Martinez
                            </p>
                            <span className="text-[#535862] text-[10px] ">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm ">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                        <div className="flex justify-end items-center rounded-[200px] ">
                          <div>
                            <img src={Avatar6} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651] font-semibold">
                              Savannah Nguyen
                            </p>
                            <span className="text-[#535862] text-[10px]">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                        <div className="flex justify-end items-center flex-row  rounded-[200px] ">
                          <div>
                            <img src={Avatar} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651]  font-semibold">
                              Albert Flores
                            </p>
                            <span className="text-[#535862] text-[10px] ">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm ">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                        <div className="flex justify-end items-center flex-row rounded-[200px] ">
                          <div>
                            <img src={Avatar4} alt="" />
                          </div>
                          <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                        </div>
                        <div className="flex flex-1 justify-start items-start flex-col gap-1">
                          <div className="flex self-stretch justify-start items-center flex-row gap-1">
                            <p className="flex-1 text-[#414651]  font-semibold">
                              Theresa Webb
                            </p>
                            <span className="text-[#535862] text-[10px] ">
                              10:30 AM
                            </span>
                          </div>
                          <p className="self-stretch text-[#535862] text-sm ">
                            Hey! How are you doing
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex self-stretch justify-start items-end flex-row gap-3 p-2">
                      <div className="flex justify-end items-center rounded-[200px] ">
                        <div>
                          <img src={Avatar2} alt="" />
                        </div>
                        <div className="flex justify-center items-center flex-row bg-[#12B76A] border-solid border-[#FFFFFF] border-[1.5px] rounded-md"></div>
                      </div>
                      <div className="flex flex-1 justify-start items-start flex-col gap-1">
                        <div className="flex self-stretch justify-start items-center flex-row gap-1">
                          <p className="flex-1 text-[#414651]  font-semibold">
                            Neighborhood Hub
                          </p>
                          <span className="text-[#535862] text-[10px] ">
                            10:30 AM
                          </span>
                        </div>
                        <p className="self-stretch text-[#535862] text-sm ">
                          Hey! How are you.. - Ella
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* 
                  
                  
                  
                  
                  
                  
                  */}
                  <div className="flex flex-1 justify-end items-start flex-col gap-6 shadow-xs border-solid border-[#E9EAEB] border rounded-3xl h-[703px]">
                    <div className="flex self-stretch flex-1 justify-start items-center flex-col gap-6 pt-[24px] px-[24px]">
                      <div className="flex self-stretch justify-between items-start flex-row gap-[112px] ">
                        <div className="flex justify-start items-center flex-row gap-3">
                          <div>
                            <img src={Avatar3} alt="" />
                          </div>
                          <div className="flex justify-start items-start flex-col gap-1">
                            <div className="flex justify-start items-end flex-row gap-1">
                              <div className="flex justify-start items-start flex-row gap-2.5">
                                <span className="text-[#414651]  font-semibold">
                                  Ella Martinez
                                </span>
                              </div>
                              <div className="flex justify-start items-center flex-row gap-1">
                                <span className="text-[#535862] text-xs font-['Roboto'] font-medium">
                                  &lt;
                                </span>
                                <span className="text-[#535862] text-sm  leading-5">
                                  ella.martinez@example.com
                                </span>
                                <span className="text-[#535862] text-xs font-['Roboto'] font-medium">
                                  &gt;
                                </span>
                              </div>
                            </div>
                            <div className="flex justify-start items-start flex-row gap-1">
                              <div
                                className="flex justify-center items-center flex-col w-[11px] h-[14px]"
                                style={{ width: "11px" }}
                              >
                                <span className="text-[#535862] text-sm ">
                                  to
                                </span>
                              </div>
                              <div className="flex justify-start items-center flex-row">
                                <div className="flex justify-start items-start flex-row gap-2.5">
                                  <span className="text-[#535862] text-sm ">
                                    me, Sidney, Sharon
                                  </span>
                                </div>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.66675 6.00065L8.00008 9.33398L11.3334 6.00065H4.66675Z"
                                    fill="#535862"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-end items-center flex-row gap-[17px]">
                          <div className="flex justify-end items-center flex-row gap-1">
                            <span className="text-[#535862] text-xs  font-medium leading-[18px]">
                              9:14 AM
                            </span>
                            <span className="text-[#535862] text-xs  font-medium leading-[18px]">
                              (8 hours ago)
                            </span>
                          </div>
                          <svg
                            width="22"
                            height="32"
                            viewBox="0 0 22 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0002 12.6673C11.9168 12.6673 12.6668 11.9173 12.6668 11.0007C12.6668 10.084 11.9168 9.33398 11.0002 9.33398C10.0835 9.33398 9.3335 10.084 9.3335 11.0007C9.3335 11.9173 10.0835 12.6673 11.0002 12.6673ZM11.0002 14.334C10.0835 14.334 9.3335 15.084 9.3335 16.0007C9.3335 16.9173 10.0835 17.6673 11.0002 17.6673C11.9168 17.6673 12.6668 16.9173 12.6668 16.0007C12.6668 15.084 11.9168 14.334 11.0002 14.334ZM11.0002 19.334C10.0835 19.334 9.3335 20.084 9.3335 21.0007C9.3335 21.9173 10.0835 22.6673 11.0002 22.6673C11.9168 22.6673 12.6668 21.9173 12.6668 21.0007C12.6668 20.084 11.9168 19.334 11.0002 19.334Z"
                              fill="#767676"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="flex self-stretch justify-start items-start flex-col gap-6 pr-[20px] pl-[50px]  h-[441px]">
                        <p className="self-stretch text-[#414651] text-sm  leading-5">
                          Aliqua id fugiat nostrud irure ex duis ea quis id quis
                          ad et. Sunt qui esse pariatur duis deserunt mollit
                          dolore cillum minim tempor enim. Elit aute irure
                          tempor cupidatat incididunt sint deserunt ut voluptate
                          aute id deserunt nisi.
                        </p>
                        <div
                          className=" w-[150px] h-[100px]"
                          style={{ width: "150px" }}
                        ></div>
                        <div className="flex justify-start items-start flex-row gap-2">
                          <div className="flex justify-center items-center flex-row gap-1 py-2 px-3  border-solid border-[#009C97] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <div className="flex justify-center items-center flex-row px-0.5">
                              <span className="text-[#009C97] text-sm  font-semibold">
                                Looking forward to it!
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center items-center flex-row gap-1 py-2 px-3 bg-[#FFFFFF] border-solid border-[#009C97] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <div className="flex justify-center items-center flex-row px-0.5">
                              <span className="text-[#009C97] text-sm  font-semibold">
                                We will be there!
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center items-center flex-row gap-1 py-2 px-3 bg-[#FFFFFF] border-solid border-[#009C97] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <div className="flex justify-center items-center flex-row px-0.5">
                              <span className="text-[#009C97] text-sm  font-semibold">
                                Thanks for the update!
                              </span>
                            </div>
                          </div>
                        </div>
                        <svg
                          width="733"
                          height="2"
                          viewBox="0 0 733 2"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 1H1030" stroke="#EDEFF1" />
                        </svg>
                        <div className="flex justify-start items-start flex-row gap-3">
                          <div className="flex justify-center items-center flex-row gap-3 py-2 px-3 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <div className="flex justify-center items-center flex-row gap-2 px-0.5">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_824_14991)">
                                  <path
                                    d="M8.33333 7.5013V4.16797L2.5 10.0013L8.33333 15.8346V12.418C12.5 12.418 15.4167 13.7513 17.5 16.668C16.6667 12.5013 14.1667 8.33464 8.33333 7.5013Z"
                                    fill="#414651"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_824_14991">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="text-[#414651] text-sm  font-semibold">
                                Reply
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center items-center flex-row gap-3 py-2 px-3 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <div className="flex justify-center items-center flex-row gap-2 px-0.5">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_824_14987)">
                                  <path
                                    d="M5.83333 6.66797V4.16797L0 10.0013L5.83333 15.8346V13.3346L2.5 10.0013L5.83333 6.66797ZM10.8333 7.5013V4.16797L5 10.0013L10.8333 15.8346V12.418C15 12.418 17.9167 13.7513 20 16.668C19.1667 12.5013 16.6667 8.33464 10.8333 7.5013Z"
                                    fill="#414651"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_824_14987">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="text-[#414651] text-sm  font-semibold">
                                Reply all
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center items-center flex-row gap-3 py-2 px-3 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <div className="flex justify-center items-center flex-row gap-2 px-0.5">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_824_14983)">
                                  <path
                                    d="M10.0002 6.66536V3.33203L16.6668 9.9987L10.0002 16.6654V13.332H3.3335V6.66536H10.0002Z"
                                    fill="#414651"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_824_14983">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="text-[#414651] text-sm  font-semibold">
                                Forward
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex self-stretch justify-start items-center flex-col border-solid border-[#E9EAEB] border-t">
                      <div className="flex self-stretch justify-start items-end flex-col gap-3 py-4 px-[24px]">
                        <div className="flex self-stretch justify-start items-start flex-row gap-3">
                          <div className="flex flex-1 justify-start items-start flex-col gap-1.5">
                            <div className="flex self-stretch justify-start items-start flex-col gap-1.5">
                              <div className="flex self-stretch justify-start items-start flex-row bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                                <div className="flex flex-1 justify-start items-center flex-row gap-2 py-2.5 pl-3.5">
                                  <div className="flex justify-start items-start w-full gap-2">
                                    <input
                                      type="text"
                                      placeholder="Message"
                                      className=" placeholder:text-gray-700 w-full p-1 outline-0 text-gray-700"
                                    />
                                  </div>
                                </div>
                                <div className="flex self-stretch justify-start items-center flex-row gap-1 py-2.5 px-3.5">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M17.6271 9.08247L10.1141 16.5955C8.40556 18.304 5.63546 18.304 3.92692 16.5955C2.21837 14.8869 2.21837 12.1168 3.92692 10.4083L11.4399 2.89529C12.579 1.75626 14.4257 1.75626 15.5647 2.89529C16.7037 4.03432 16.7037 5.88105 15.5647 7.02008L8.34633 14.2385C7.77682 14.808 6.85345 14.808 6.28394 14.2385C5.71442 13.6689 5.71442 12.7456 6.28394 12.1761L12.6184 5.84157"
                                      stroke="#A4A7AE"
                                      strokeWidth="1.66667"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-center items-center flex-row p-3 bg-[#009C97] border-solid border-[undefined] border-2 rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),inset_0px_0px_0px_1px_rgba(10,13,18,0.18)]">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.74976 11.2501L17.4998 2.50014M8.85608 11.5235L11.0462 17.1552C11.2391 17.6513 11.3356 17.8994 11.4746 17.9718C11.5951 18.0346 11.7386 18.0347 11.8592 17.972C11.9983 17.8998 12.095 17.6518 12.2886 17.1559L17.7805 3.08281C17.9552 2.63516 18.0426 2.41133 17.9948 2.26831C17.9533 2.1441 17.8558 2.04663 17.7316 2.00514C17.5886 1.95736 17.3647 2.0447 16.9171 2.21939L2.84398 7.71134C2.34808 7.90486 2.10013 8.00163 2.02788 8.14071C1.96524 8.26129 1.96532 8.40483 2.0281 8.52533C2.10052 8.66433 2.34859 8.7608 2.84471 8.95373L8.47638 11.1438C8.57708 11.183 8.62744 11.2026 8.66984 11.2328C8.70742 11.2596 8.74028 11.2925 8.76709 11.3301C8.79734 11.3725 8.81692 11.4228 8.85608 11.5235Z"
                                stroke="white"
                                strokeWidth="1.66667"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateEmails;
